import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getRequestArchivedPipelines,
  getRequestArchivedPipelinesCount,
} from '../../../../../api'
import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import {
  useIsMountedRef,
  useNotification,
  useUserData,
} from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import { RequestArchivedPipelinesModal } from '../../../RequestArchivedPipelinesModal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileHeaderArchivedPipelines({ requestId }) {
  const { t } = useTranslation()

  const {
    handleCloseModal,
    handleReloadAfterChange,
    handleUpdateEntity,
    outboundUuid,
    setModal,
  } = useRequestProfileContext()
  const { handleAddSuccessNotification } = useNotification()
  const [archivedPipelinesCount, setArchivedPipelinesCount] = useState(0)

  const currentUser = useUserData()
  const isStaff = isStaffUser(currentUser)

  const isMountedRef = useIsMountedRef()

  function handleLoadArchivedPipelinesCount() {
    if (requestId && isStaff && !outboundUuid) {
      return getRequestArchivedPipelinesCount(requestId)
        .then(({ data }) => {
          if (isMountedRef.current) {
            setArchivedPipelinesCount(data.count)
          }
        })
        .catch(error => {
          if (isMountedRef.current) {
            setArchivedPipelinesCount(0)
          }

          throw error
        })
    }
  }

  useEffect(() => {
    handleLoadArchivedPipelinesCount()?.catch(console.error)
  }, [isStaff, requestId])

  async function handleRestorePipeline(pipelineId) {
    return handleUpdateEntity({ pipeline: pipelineId }, null).then(() => {
      handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.pipeline)
      handleCloseModal()
      handleAddSuccessNotification({
        text: t(
          'RequestProfile.ArchivedPipelinesModalRestoreSuccessNotificationTextKey'
        ),
        title: t(
          'RequestProfile.ArchivedPipelinesModalRestoreSuccessNotificationTitleKey'
        ),
      })
    })
  }

  function handleLoadArchivedPipelines() {
    return getRequestArchivedPipelines(requestId)
  }

  function handleOpenArchivedPipelinesModal() {
    setModal(
      <RequestArchivedPipelinesModal
        loadArchivedPipelines={handleLoadArchivedPipelines}
        onClose={handleCloseModal}
        onRestore={handleRestorePipeline}
      />
    )
  }

  return {
    archivedPipelinesCount,
    handleLoadArchivedPipelinesCount,
    handleOpenArchivedPipelinesModal,
  }
}
